import { DateTime } from 'luxon';

export const isBeforeCurrentTime = (timeInMillis: number): boolean => {
	const currentTime = DateTime.now().toMillis(); // Get current time in milliseconds from Luxon
	return currentTime < timeInMillis;
};
